import Header from "../components/template-components/header/header.js";
import "../components/elements/dialog/dialog.js";

const Factory = {
	".js-Header": Header,
};

Object.keys(Factory).forEach((key) => {
	Array.from(document.querySelectorAll(key)).map(
		(element) => new Factory[key](element),
	);
});
